import { Link } from 'react-router-dom'

import { Badge, BadgeType, Member } from '@tribeplatform/gql-client/types'
import { T } from '@tribeplatform/react-components/i18n'
import { MemberBadge } from '@tribeplatform/react-components/MemberBadge'
import { Tooltip } from '@tribeplatform/react-ui-kit/Tooltip'

export const BadgeRow = ({
  badge,
  member,
  onClick,
  dragHandle,
}: {
  badge: Badge
  member: Member
  onClick: (badge: Badge) => void
  dragHandle?: React.ReactNode
}) => {
  const isSmart = badge?.type && badge?.type !== BadgeType.Manual
  return (
    <Link
      onClick={() => onClick(badge)}
      to="#"
      className="flex-1 border border-line-subdued rounded-base p-2 px-3 bg-surface hover:bg-surface-hovered flex space-s-2 items-center"
    >
      <span className="min-w-0 flex-grow flex items-center space-s-1">
        {dragHandle}
        <span className="truncate">{badge.name}</span>
        {isSmart && (
          <Tooltip>
            <Tooltip.Trigger className="inline-block text-content-subdued text-sm">
              <T
                defaultMessage="(smart)"
                id="Admin.MemberBadges.Tooltip.Smart"
              />
            </Tooltip.Trigger>
            <Tooltip.Panel>
              <T
                defaultMessage="Smart badges are automatically assigned and unassigned"
                id="Admin.MemberBadges.Tooltip.Smart.Description"
              />
            </Tooltip.Panel>
          </Tooltip>
        )}
      </span>
      <MemberBadge
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        member={member}
        badge={badge}
        className="overflow-hidden max-w-[100px]"
      />
    </Link>
  )
}
